import React, {Component} from "react";
import OrderPtt from "./VentanillaOrderPttView";
import {VentanillaService} from "../../../service/ventanilla/VentanillaService";
import {Growl} from "primereact/growl";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {numberWithCommaText} from "../../../utils/formatters/Numbers";
import {strToDate} from "../../../utils/formatters/Date";
import {replaceAccents} from "../../../utils/formatters/Accent";

export default class VentanillaOrderPttContainer extends Component {
    constructor(props) {
        super(props);

        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.ventanillaService = new VentanillaService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveOrder = this.saveOrder.bind(this);
        this.saveDataOrderBorrower = this.saveDataOrderBorrower.bind(this);

        this.state = {
            today: new Date(),
            isLoading: true,
            orderPtt: [this.getOrderPtt()],
            folio: this.props.location.state.folio,
            validDate: true,
            returnPath: this.props.location.state.returnPath
        }
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: this.state.returnPath,
        });
    }

    getOrderPtt() {
        this.loading();
        return this.ventanillaService.getOrderPtt(this.props.location.state.folio).then(
            data => {
                let valueDate = strToDate(data.payload[0][0].fecValor);
                data.payload[0][0].tasa = (data.payload[0][0].tasa * 100.00).toFixed(2);
                data.payload[0][0].sobreTasa = (data.payload[0][0].sobreTasa * 100.00).toFixed(2);
                data.payload[0][0].cantidadDisponible = data.payload[0][0].cantidad;
                data.payload[0][0].precio = valueDate > this.state.today ? "" : data.payload[0][0].precio;

                this.setState({
                    isLoading: false,
                    orderPtt: data.payload[0],
                })
            });
    }

    validateOrder() {
        let msgError = '';

        if (!this.state.validDate) {
            msgError = "El Plazo es incorrecto ya que el vencimiento no puede ser sábado, domingo o en día festivo";
        } else {
            let fields = [];

            if (
                this.state.orderPtt[0].cantidad === undefined ||
                this.state.orderPtt[0].cantidad === "" ||
                this.state.orderPtt[0].cantidad === "0" ||
                this.state.orderPtt[0].cantidad * 1 > this.state.orderPtt[0].cantidadDisponible

            ) {
                fields.push("Títulos");
            }

            if (
                this.state.orderPtt[0].plazo === undefined ||
                this.state.orderPtt[0].plazo === "" ||
                this.state.orderPtt[0].plazo === "0") {
                fields.push("Plazo");
            }

            if (fields.length > 0) {
                msgError = "Favor de revisar los siguientes campos: ";

                fields.map(field => {
                    msgError = msgError + field + ', ';
                    return '';
                });
            }
        }

        return msgError;
    }

    saveDataOrderBorrower(event) {
        const {name, value} = event.target;
        let orderPtt = this.state.orderPtt;
        orderPtt[0][name] = value;
        this.setState({orderPtm: orderPtt,})
    }

    saveOrder() {
        let msg = this.validateOrder();
        if (msg !== '') {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: msg
            });
            return '';
        }
        this.loading();
        this.ventanillaService.takeOrderBorrowerVentanilla(
            this.state.folio, this.state.orderPtt[0]
        ).then(response => {

            this.setState({isLoading: false});
            if (response.error !== "") {
                this.growl.show({
                    severity: 'error',
                    summary: 'Error.',
                    detail: replaceAccents(response.error)
                });
            } else {
                let message = {
                    severity: 'success',
                    summary: 'Éxito',
                    detail: replaceAccents(response.message),
                };
                this.props.history.push({
                    pathname: this.state.returnPath,
                    message: message,
                });
            }
        });
    }


    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        this.confMsg = <ConfirmationMessage nameButton="Guardar"
                                            ref={this.setConfirmationRef}
                                            legend={
                                                "¿Está seguro que desea agregar una postura con los siguientes valores?" +
                                                "|Cantidad = " + numberWithCommaText(this.state.orderPtt[0].cantidad) +
                                                "|Plazo = " + numberWithCommaText(this.state.orderPtt[0].plazo) +
                                                "|Tasa = " + numberWithCommaText(this.state.orderPtt[0].tasa)}
                                            action={this.saveOrder}/>;


        return <OrderPtt
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            confMsg={this.confMsg}
            orderPtt={this.state.orderPtt}
            handleReturnButton={this.handleReturnButton}
            saveDataOrderBorrower={this.saveDataOrderBorrower}
        />

    }
}